import { useEffect, useRef } from "react";
import { BOOKING } from "../../data/mock";

export default function Booking() {
  const ref = useRef(null);

  useEffect(() => {
    // Inject Cal.com embed script once
    if (window.__calInited) {
      window.__calRender?.();
      return;
    }
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.innerHTML = `
      (function (C, A, L) {
        let p = function (a, ar) { a.q.push(ar); };
        let d = C.document;
        C.Cal = C.Cal || function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () { p(api, arguments); };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === "string") {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ["initNamespace", namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
      })(window, "https://app.cal.com/embed/embed.js", "init");
      Cal("init", "aa-booking", { origin: "https://cal.com" });
      Cal.ns["aa-booking"]("inline", {
        elementOrSelector: "#aa-cal-inline",
        calLink: "${BOOKING.calUsername}",
        layout: "month_view"
      });
      Cal.ns["aa-booking"]("ui", {
        styles: { branding: { brandColor: "#C45F45" } },
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    `;
    document.body.appendChild(s);
    window.__calInited = true;
  }, []);

  return (
    <section
      id="book"
      data-testid="booking-section"
      className="py-24 md:py-32 bg-cream-alt border-y border-[#E5E0D8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-2xl mb-10">
          <span className="eyebrow" data-testid="booking-eyebrow">Book a call</span>
          <h2
            data-testid="booking-heading"
            className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mt-6 text-navy"
          >
            Pick a time that
            <span className="italic text-terracotta"> suits you.</span>
          </h2>
          <p className="mt-5 text-lg text-ink-muted">
            15-minute discovery calls are complimentary. Longer paid consulting sessions
            are also bookable below.
          </p>
        </div>

        <div
          id="aa-cal-inline"
          ref={ref}
          data-testid="cal-inline-embed"
          style={{ width: "100%", minHeight: 660, overflow: "hidden" }}
          className="bg-cream border border-[#E5E0D8]"
        />

        <p className="mt-6 text-sm text-ink-muted">
          Calendar not loading?{" "}
          <a
            href={BOOKING.calUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cal-fallback-link"
            className="text-terracotta hover:text-navy font-semibold border-b border-terracotta"
          >
            Open my booking page directly →
          </a>
        </p>
      </div>
    </section>
  );
}
